module.exports = __webpack_public_path__ + "static/screenshot-ba53a5bc63a1211f27dacde540244ef5.png";